import { injectStaticFormFields } from '../adapters/formResponseAdapter';

const DEFAULT_HOT_CRITERIA = [
  {
    name: 'is_hot_level_1',
    operation: [{ name: 'or', items: [] }],
  },
];

export const isStatusField = (field) => field?.statusOption === 'is_status';
export const isSubStatusField = (field) => field?.statusOption === 'is_sub_status';

export function isStaticColumnField(field) {
  return field?.is_static_column === true;
}

/** System/injected fields (lead_id + static columns) — used for badges and validation skip. */
export function isSystemBuilderField(field) {
  if (!field) return true;
  if (field.key_name === 'lead_id') return true;
  return isStaticColumnField(field);
}

/** @deprecated alias — use isSystemBuilderField */
export function isStaticBuilderField(field) {
  return isSystemBuilderField(field);
}

/** Legacy parity: key name locked for lead_id, static columns and primary fields. */
export function isFieldNameLocked(field) {
  if (!field) return true;
  if (field.key_name === 'lead_id') return true;
  if (isStaticColumnField(field)) return true;
  if (field.is_primary) return true;
  return false;
}

/** Display alias is editable for all fields, including system/static columns. */
export function isAliasNameLocked() {
  return false;
}

export function isFieldTypeLocked(field) {
  return isSystemBuilderField(field);
}

/** System fields allow alias edits only — key, type and advanced settings stay locked. */
export function isSystemFieldAliasOnlyMode(field) {
  return isSystemBuilderField(field);
}

/** @deprecated use isSystemFieldAliasOnlyMode */
export function canEditAliasOnly(field) {
  return isSystemFieldAliasOnlyMode(field);
}

export function isDrawerSubmitDisabled() {
  return false;
}

/** Persist only safe properties when saving a system field from the drawer. */
export function buildFieldDrawerSavePayload(field, draft, settings) {
  if (!isSystemBuilderField(field)) {
    return { ...draft, settings };
  }
  return {
    ...field,
    alias_name: String(draft?.alias_name ?? field?.alias_name ?? '').trim(),
  };
}

export function isFieldDeletable(field) {
  return !isSystemBuilderField(field) && !field?.is_primary;
}

export function createEmptyFormState() {
  const fields = injectStaticFormFields([]).map((field, index) => ({
    ...field,
    order_id: index + 1,
    item_id: index + 1,
    statusOption: field.statusOption ?? '',
    status_parent_key: field.status_parent_key ?? '',
    is_encrypted: field.is_encrypted ?? false,
    groupId: field.groupId ?? '',
  }));

  return {
    leads_form_name: '',
    description: '',
    use_for_ai: 0,
    leads_form_items: fields,
    group_options: [],
    global_hot_lead_criteria: DEFAULT_HOT_CRITERIA,
    hotness_mapping: {},
    templates: [],
  };
}

export function normalizeFormSnapshot(form) {
  return {
    leads_form_name: form?.leads_form_name ?? '',
    description: form?.description ?? '',
    use_for_ai: form?.use_for_ai === 1 || form?.use_for_ai === true ? 1 : 0,
    leads_form_items: (form?.leads_form_items ?? []).map((field, index) => ({
      ...field,
      order_id: index + 1,
    })),
    group_options: form?.group_options ?? [],
    global_hot_lead_criteria: form?.global_hot_lead_criteria ?? [],
    hotness_mapping: form?.hotness_mapping ?? {},
    templates: form?.templates ?? [],
  };
}

export function getNextFieldItemId(fields = []) {
  const maxId = fields.reduce(
    (max, field) => Math.max(max, Number(field?.item_id) || 0),
    0
  );
  return maxId + 1;
}
